import React, { useEffect } from "react"
import { useDispatch } from 'react-redux'
import User from '../../../Api/User/User'
import { returnCurrentUser } from '../../../Api/User/userSlice'
import { addManyElementsData, createOrUpdateElementData, returnSingleFormElementData, updateElementDisabledStatus, updateElementLoadingStatus } from '../../../FormElements/formsDataSlice'
import { addNewForm } from '../../../FormElements/formsSlice'
import FormValidator from '../../../FormElements/FormValidator'
import GenerateForm from '../../../FormElements/GenerateForm'

export default function ProfileUpdatePasswordSection(){

    const dispatch = useDispatch()

    const currentUser = returnCurrentUser()

    const formDetails = {
        name: "profile_password",
        elemPrefix: "profile_password_"
    }

    const elemPrefix = formDetails.elemPrefix

    /**
     * Update button loading
     */
    const updateButtonLoadingStatus = (loading: boolean) => {
        dispatch(
            updateElementLoadingStatus({
                name: elemPrefix + "submit",
                loading
            })
        )
    }

    /**
     * Update button loading
     */
    const updateButtonDisabledStatus = (status: boolean) => {
        dispatch(
            updateElementDisabledStatus({
                name: elemPrefix + "submit",
                disabled: status
            })
        )
    }

    /**
     * Get single form element data value
     */
    const getSingleFormElementValue = (name: string) => returnSingleFormElementData(elemPrefix + name).value

    /**
     * Handle submit
     */
    const handleSubmit = () => {
        updateButtonLoadingStatus(true)
        // setTimeout(() => updateButtonLoadingStatus(false), 1000)

        const password: string = getSingleFormElementValue("password")
        const otp: string = getSingleFormElementValue("otp")

        const requiredFiels: Array<string> = [
            elemPrefix + "password",
            elemPrefix + "otp",
        ]

        /**
         * Form Validator
         */
        const formValidator = new FormValidator(requiredFiels)

        if (formValidator.isValid().valid){

            const userApp = new User()
            userApp.updateCurrentUserPassword(password, otp)
                .then(response => {
                        
                    const { status, statusText, data } = response

                    switch(status){

                        case 200:
                            dispatch(
                                createOrUpdateElementData({
                                    name: elemPrefix + "alert",
                                    value: data.message! ? data.message : statusText,
                                    severity: "success"
                                })
                            )

                            dispatch(
                                createOrUpdateElementData({
                                    name: elemPrefix + "password",
                                    value: "",
                                })
                            )
                            break

                    }

                    updateButtonLoadingStatus(false)
                    updateButtonDisabledStatus(true)

                })
                .catch(error => {
                    updateButtonLoadingStatus(false)
                    
                    const response = error.response
                    console.log(response)
                    
                    switch(response.status){

                        default:
                            dispatch(
                                createOrUpdateElementData({
                                    name: elemPrefix + "alert",
                                    value: response.data! ? response.data.message! ? response.data.message : "" : response.statusText,
                                    severity: "error"
                                })
                            )
                    }
                
                })

        }else{
            updateButtonLoadingStatus(false)
            formValidator.showRequiredFields(dispatch)
        }

    }

    /**
     * Use effect
     */
    useEffect(() => {

        /**
         * Add new form
         */
         dispatch(
            addNewForm({
                name: formDetails.name,
                elements: [
                    {
                        type: "TextField",
                        fieldType: "password",
                        xs: 12,
                        id: elemPrefix + "password",
                        label: "New Password",
                        fullWidth: true
                    },
                    {
                        type: "TwoFactorAuth",
                        fieldType: "number",
                        xs: 12,
                        id: elemPrefix + "otp",
                        label: "Enter 6-digit code from Google Authenticator to change the password",
                        submitFormOnPressingEnter: true,
                        fullWidth: true,
                    },
                    {
                        type: "Alert",
                        xs: 12,
                        label: "",
                        id: elemPrefix + "alert"
                    },
                    {
                        type: "Button",
                        xs: 12,
                        id: elemPrefix + "submit",
                        label: "Update",
                        fullWidth: false,
                        onClick: () => {},
                        isSubmit: true
                    }
                ]
            })
        )

        /**
         * Add new form elements data
         */
        dispatch(
            addManyElementsData([
                {
                    name: elemPrefix + "password",
                    value: ""
                },
                {
                    name: elemPrefix + "otp",
                    value: ""
                },
                {
                    name: elemPrefix + "alert",
                    value: "Test",
                    severity: "info",
                    hidden: true
                },
                {
                    name: elemPrefix + "submit",
                    value: ""
                }
            ])
        )

    }, [])

    return(
        <div className="user-details-form-container">
            <div className="content-of-user-details-form-container">
                <GenerateForm name={formDetails.name} handleSubmitForm={handleSubmit} />
            </div>
        </div>
    )
}